import NotificationCenterVM from './notification-center-vm';

// The viewmodel needs structured data,
// so on fail give it this so everything
// still functions.
const FAILURE_FIXTURE = {
  'calendar': {
    'count': 0,
    'fresh_count': 0,
    'items': [],
  },
  'updates': {
    'count': 0,
    'fresh_count': 0,
    'items': []
  }
};

let cache = null;

let delegateEvents = function(element) {
  // use .off() to ensure each event handler gets attached only once
  $('.js_notification-center-target')
    .off('click.notificationcenter.hide')
    .on('click.notificationcenter.hide', function(e){
      clearWindows(e);
    });
  $('body')
    .off('click.notificationcenter.hideall')
    .on('click.notificationcenter.hideall', function(e){
      clearWindows(e);
    });
};

  // Make the ajax request
let getContent = function(element) {
  // Don't fire unless the navigation exists
  if($('[data-module-amd=\'CommonNotificationCenter\']').length) {

    let request = new Kadenze.AjaxRequest({
      type: 'GET',
      url: Kadenze.Routes.grouped_notifications_path()
    });

    request.done(function(response) {
      cache = response;
      createViewModel(element, cache);
    });

    request.fail(function() {
      createViewModel(element, FAILURE_FIXTURE);
    });
  }
};

  // Parse JSON response
let parseList = function(element, response) {
  let listTypes = $(element).data('notificationLists').split(','),
    lists = [];

  _.each(listTypes, function(type, i) {
    var title = type;
    var responseKey = type;
    if (title === 'reminders') {
      responseKey = 'calendar';
    }
    let listResponse = response[responseKey];
    var listObj = {
      title: title,
      items: listResponse ? listResponse.items : [],
      count: listResponse ? listResponse.count : 0,
      fresh_count: listResponse ? listResponse.fresh_count : 0,
      isFirst: i === 0,
      displayCalendar: title === 'today',
    };
    lists.push(listObj);
  });

  return _.flatten(lists);
};

  // Create a viewModel for each set of lists
let createViewModel = function(element, data) {
  var $el = $(element),
    params = {
      listData: parseList(element, data),
      windowTrigger: element,
      template: 'templates/' + $el.data('notificationTemplate'),
      drawMiniCalendar: $el.data('notificationDrawminicalendar')
    };

    // If the VM exists just re build its list
  if($el.data('VM')) {

    if(!$el.data('VM').isActive()) {
      $el.data('VM').buildList(params.listData, true);
    }
  } else {
    let vm = new NotificationCenterVM(params);

    $el.data('VM', vm);

    // click handler to show dropdowns for desktop-view notification center instances
    $el.on('click.notificationCenter', function(event) {
      var $target = $(event.target);
      // '.js_notification-center-target' class is to specifically target desktop versions of the notification center links - we don't want to show the dropdowns for mobile
      if($target.hasClass('.js_notification-center-target')) {
        $target.data('VM').toggle();
      } else {
        var $maybeTarget = $target.closest('.js_notification-center-target');
        if($maybeTarget.length) {
          $maybeTarget.data('VM').toggle();
        }
      }
    });

  }
};

  // Checks if an event is inside a window or not
let actionInsideNotificationWindow = function(event) {
  return $(event.target).closest('.notification-center').length || $(event.target).closest('.clndr-main').length ? true : false;
};
      
  // Clears all windows, event must be passed in because event.target is needed
let clearWindows = function(event) {
  var $windows = $('[data-module-amd=\'CommonNotificationCenter\']');

  $windows.each(function(i, el) {
    var vmInstance = $(el).data('VM');

    if(typeof(vmInstance) != 'undefined' && vmInstance.isActive() && !actionInsideNotificationWindow(event)) {
      vmInstance.hide();
    }
  });
};
  
export default {
  init: function(node) {
    console.log('Initializing NotificationCenter for: ' + $(node).data('notificationLists'));
    getContent(node);
    delegateEvents(node);
  },
  refresh: function (node) {
    getContent(node);
    delegateEvents(node);
  }
};
